export const L10N = {
  ACTION_CONTINUE: { id: 'core.action.continue' },
  ACTION_PAY_NOW: { id: 'core.action.pay_now' },
  ACTION_SAVE: { id: 'common.action.save' },
};
